import { deleteQueueDatabase } from './upload-queue';

/**
 * Forget everything identity-scoped this browser holds. Runs on sign-out
 * and account deletion: on a shared device the next person must not see
 * the previous user's own-pin markers, recent submissions, or queued
 * photos. `trail.intro_seen` survives on purpose — it is device-level,
 * not identity-level.
 *
 * Best-effort by design, mirroring clearToken()'s never-trap-the-user
 * discipline: each store clears independently, and the IndexedDB delete
 * is raced against a 1s timeout so a wedged delete (another tab holding
 * a connection) cannot block the sign-out flow — the reload that follows
 * finishes the job on next open.
 */

const LOCAL_KEYS = ['trail.own_pin_stubs', 'trail.my_recent_submissions'];
const SESSION_KEYS = ['trail.just_submitted_version', 'trail.review_pending', 'trail.sign_in_return'];

export async function clearLocalUserData(): Promise<void> {
  for (const key of LOCAL_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Storage unavailable (private mode quirks) — nothing to clear.
    }
  }
  for (const key of SESSION_KEYS) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // Same.
    }
  }
  try {
    await Promise.race([
      deleteQueueDatabase(),
      new Promise<void>((resolve) => setTimeout(resolve, 1000)),
    ]);
  } catch {
    // No IndexedDB, or the delete failed — best-effort.
  }
}
